import { useMutation, UseMutationResult } from 'react-query';

import { useAuth } from 'src/hooks';
import { activityStore } from '../store/activityStore';

import { activityLogDownloadAsCsv } from 'src/utils/urls';
import { getLengthToRequest, trimValues } from 'src/utils/common';

import { ActivityLogFilterType } from '../types/filterOptionsType';
import { getColumnFromId } from 'src/utils/filterHelper';
import { filterSortOptionsActivityLog } from '../utils/activityFilterConstants';
import { allLogListReqData } from '../utils/allLogListReqData';
import { getSourceSearchValue } from '../utils/common';

async function postDownloadCsv({
  token,
  tokenType,
  requestData,
  requestType,
}: TArguments): Promise<TResult> {
  const pageParam = activityStore.getState().pageParam;
  requestData.append('start', `${0}`);
  const lengthToRequest = getLengthToRequest(pageParam);
  requestData.append('length', `${lengthToRequest}`);
  const response = await fetch(activityLogDownloadAsCsv(requestType), {
    method: 'POST',
    headers: {
      Authorization: `${tokenType} ${token}`,
    },
    body: requestData,
  });

  if (response.status === 204) return 'Success';
  else return response.json();
}

export type ValidationError = { Message?: string };
export type TResult = string | ValidationError;
export type TError = { message?: string };

export type TArguments = {
  token: string;
  tokenType: string;
  requestData: any;
  requestType?: string;
};

export type TVariables = {
  filterOptions: ActivityLogFilterType;
  pageParam: number;
};

function setDownloadCsvRequestData(
  filterOptions: ActivityLogFilterType,
  isExternalUser?: boolean,
): FormData {
  const formData: any = new URLSearchParams();

  formData.append('draw', '1');
  // formData.append('length', `${100}`);
  formData.append('timezoneOffset', `${new Date().getTimezoneOffset()}`);
  formData.append('columns[0][data]', 'CID');
  formData.append('columns[0][name]', '');
  formData.append('columns[0][searchable]', 'true');
  formData.append('columns[0][orderable]', 'true');
  formData.append('columns[0][search][regex]', 'false');
  formData.append('columns[0][search][ApplyExactMatch]', ''),
    formData.append(
      'columns[0][search][value]',
      filterOptions && filterOptions.cid ? trimValues(filterOptions.cid) : '',
    );

  formData.append('columns[1][data]', 'PID');
  formData.append('columns[1][name]', '');
  formData.append('columns[1][searchable]', 'true');
  formData.append('columns[1][orderable]', 'true');
  formData.append('columns[1][search][regex]', 'false');
  formData.append('columns[1][search][ApplyExactMatch]', ''),
    formData.append(
      'columns[1][search][value]',
      filterOptions && filterOptions.pid ? trimValues(filterOptions.pid) : '',
    );

  formData.append('columns[2][data]', 'Activity');
  formData.append('columns[2][name]', '');
  formData.append('columns[2][searchable]', 'true');
  formData.append('columns[2][orderable]', 'true');
  formData.append('columns[2][search][regex]', 'false');
  formData.append('columns[2][search][ApplyExactMatch]', ''),
    formData.append(
      'columns[2][search][value]',
      filterOptions && filterOptions.activity
        ? trimValues(filterOptions.activity)
        : '',
    );

  formData.append('columns[3][data]', 'CreatedOn');
  formData.append('columns[3][name]', '');
  formData.append('columns[3][searchable]', 'true');
  formData.append('columns[3][orderable]', 'true');
  formData.append('columns[3][search][regex]', 'false');
  formData.append('columns[3][search][ApplyExactMatch]', ''),
    formData.append(
      'columns[3][search][value]',
      filterOptions && filterOptions.createdOn
        ? trimValues(filterOptions.createdOn)
        : '',
    );

  formData.append('columns[4][data]', 'CreatedBy');
  formData.append('columns[4][name]', '');
  formData.append('columns[4][searchable]', 'true');
  formData.append('columns[4][orderable]', 'true');
  formData.append('columns[4][search][regex]', 'false');
  formData.append('columns[4][search][ApplyExactMatch]', ''),
    formData.append(
      'columns[4][search][value]',
      filterOptions && filterOptions.createdBy
        ? trimValues(filterOptions.createdBy)
        : '',
    );

  formData.append('columns[5][data]', 'UserName');
  formData.append('columns[5][name]', '');
  formData.append('columns[5][searchable]', 'true');
  formData.append('columns[5][orderable]', 'true');
  formData.append('columns[5][search][regex]', 'false');
  formData.append('columns[5][search][ApplyExactMatch]', ''),
    formData.append(
      'columns[5][search][value]',
      filterOptions && filterOptions.userName
        ? trimValues(filterOptions.userName)
        : '',
    );

  formData.append('columns[6][data]', 'PersonId');
  formData.append('columns[6][name]', '');
  formData.append('columns[6][searchable]', 'true');
  formData.append('columns[6][orderable]', 'true');
  formData.append('columns[6][search][regex]', 'false');
  formData.append('columns[6][search][ApplyExactMatch]', ''),
    formData.append(
      'columns[6][search][value]',
      filterOptions && filterOptions.personId
        ? trimValues(filterOptions.personId)
        : '',
    );
  formData.append('columns[7][data]', 'PersonAlertId');
  formData.append('columns[7][name]', '');
  formData.append('columns[7][searchable]', 'true');
  formData.append('columns[7][orderable]', 'true');
  formData.append('columns[7][search][regex]', 'false');
  formData.append('columns[7][search][ApplyExactMatch]', ''),
    formData.append(
      'columns[7][search][value]',
      filterOptions && filterOptions.personAlertId
        ? trimValues(filterOptions.personAlertId)
        : '',
    );
  formData.append('columns[8][data]', 'FormId');
  formData.append('columns[8][name]', '');
  formData.append('columns[8][searchable]', 'true');
  formData.append('columns[8][orderable]', 'true');
  formData.append('columns[8][search][regex]', 'false');
  formData.append('columns[8][search][ApplyExactMatch]', ''),
    formData.append(
      'columns[8][search][value]',
      filterOptions && filterOptions.submissionNumber
        ? trimValues(filterOptions.submissionNumber)
        : '',
    );

  formData.append('columns[9][data]', 'ReportFileName');
  formData.append('columns[9][name]', '');
  formData.append('columns[9][searchable]', 'true');
  formData.append('columns[9][orderable]', 'true');
  formData.append('columns[9][search][regex]', 'false');
  formData.append('columns[9][search][ApplyExactMatch]', ''),
    formData.append(
      'columns[9][search][value]',
      filterOptions && filterOptions.reportFileName
        ? trimValues(filterOptions.reportFileName)
        : '',
    );

  formData.append('columns[10][data]', 'AccountList');
  formData.append('columns[10][name]', '');
  formData.append('columns[10][searchable]', 'true');
  formData.append('columns[10][orderable]', 'true');
  formData.append('columns[10][search][regex]', 'false');
  formData.append('columns[10][search][ApplyExactMatch]', ''),
    formData.append(
      'columns[10][search][value]',
      filterOptions && filterOptions.accountCidPid
        ? trimValues(filterOptions.accountCidPid)
        : '',
    );

  if (isExternalUser) {
    formData.append('columns[11][data]', 'IsADUser');
    formData.append('columns[11][name]', '');
    formData.append('columns[11][searchable]', 'true');
    formData.append('columns[11][orderable]', 'true');
    formData.append('columns[11][search][regex]', 'false');
    formData.append('columns[11][search][ApplyExactMatch]', ''),
      formData.append(
        'columns[11][search][value]',
        getSourceSearchValue(filterOptions?.source),
      );
  }

  formData.append(
    'order[0][column]',
    getColumnFromId(filterOptions.sortType, filterSortOptionsActivityLog),
  );
  formData.append('order[0][dir]', filterOptions.sortOrder);

  formData.append(
    'search[value]',
    `${trimValues(filterOptions.keywordSearch)}`,
  );
  formData.append('search[regex]', 'false');

  return formData;
}

function useDownloadCsv(
  requestType?: string,
  isExternalUser?: boolean,
): UseMutationResult<TResult, TError, TVariables, unknown> {
  const { token, tokenType } = useAuth();

  return useMutation(async (params: TVariables) => {
    const requestData =
      requestType === 'all'
        ? allLogListReqData(params.filterOptions)
        : setDownloadCsvRequestData(params.filterOptions, isExternalUser);

    const result = await postDownloadCsv({
      token,
      tokenType,
      requestData,
      requestType,
    });
    if (result === 'Success') return result;
    else throw result;
  });
}
export { useDownloadCsv };
